import React, { useEffect } from "react";
// import "../Css/Contact.css";
import Footer from "./Footer";
import { GrMail } from "react-icons/gr";
import { MdCall } from "react-icons/md";
import Simpleform from "./Simpleform";
import { motion, useScroll } from "framer-motion";
import Aos from "aos";
import "aos/dist/aos.css";
function Contact() {
  useEffect(() => {
    document.title = "Contact";
  });
  useEffect(() => {
    Aos.init({ duration: 500 });
  }, []);
  const { scrollYProgress } = useScroll();
  return (
    <div>
      <motion.div
        style={{
          scaleX: scrollYProgress,
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          background: "yellow",
          height: 4,
          transformOrigin: "0%",
        }}
      />

      <div id="contactmain">
        <h1 className="text-center" data-aos="fade-down">
          Get in Touch
        </h1>
        <div className="container-fluid">
          <div className="row simplereow">
            <div className="col-xl-5" data-aos="zoom-in">
              <span id="shy">DON'T BE SHY</span>
              <p>
                Feel free to get in touch with me. I am always open to
                discussing new projects, creative ideas or opportunities to be
                part of your visions.
              </p>
              <i>{<GrMail />}</i>
              <p>
                Mail me <br />
                montukharb868@gmail.com
              </p>
              <i>{<MdCall />}</i>
              <p>
                Call me <br />
                +91-8059202360
              </p>
            </div>
            <div className="col-xl-5" data-aos="zoom-in">
              <Simpleform />
            </div>
          </div>
        </div>
      </div>

      <div>
        <Footer />
      </div>
    </div>
  );
}
export default Contact;
